webpackJsonp([18],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'meetingroom',
  metaInfo: {
    title: 'Meeting room in downtown of Bratislava'
  },
  data: function data() {
    return {
      href: {
        iframes: ["https://www.google.com/maps/embed?pb=!4v1548615947594!6m8!1m7!1sCAoSLEFGMVFpcE1uOUhxclBDNFJtN0VsaDRfYnZzbFRKaldSdGlJZER3cTR6Tkcz!2m2!1d48.14466111111111!2d17.1154!3f272.452135499486!4f-1.9685896130948208!5f0.4000000000000002"]
      },
      orderPrices: {
        meetingRoom: 10
      }
    };
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, ".button.is-black.is-block.is-large.meeting{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}.notification{padding:0}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/MeetingRoom.vue"],"names":[],"mappings":"AACA,2CACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,cACA,SAAW,CACV","file":"MeetingRoom.vue","sourcesContent":["\n.button.is-black.is-block.is-large.meeting {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.notification {\npadding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("0420e664", content, true, {});

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingroom"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/waomeeting-01-4.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/recording_podcast.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Meeting room 🤝")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("🧠 Perfect for brainstorming and meeting clients")]), _vm._v(" "), _c('p', [_vm._v("📍 Downtown location")]), _vm._v(" "), _c('p', [_vm._v("💺 Capacity 10 seats ")]), _vm._v(" "), _c('p', [_vm._v("📽 Projector with Chromecast")]), _vm._v(" "), _c('p', [_vm._v("🎨 Whiteboard")]), _vm._v(" "), _c('p', [_vm._v("🎧 Acoustically insulated ")]), _vm._v(" "), _c('p', [_vm._v("🎧 Great for Podcasts")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our meeting room you are supporting community space")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to book Progressbar Meeting Room!"
    }
  }, [_vm._v("\n            Book meeting room")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/spoznajkandidata.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/meeting_room_february_2020.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/pb-02.jpg",
      "loading": "lazy",
      "alt": "meeting room bratislava coworking"
    }
  })])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.c738dba3efb87241c0c1.js